/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import React, { useEffect, useState } from 'react';

import { getVoucherLogs } from './store/activityLog.actions';
import { GET_ACTIVITY_LOG_VOUCHER_FAILURE } from './store/activityLog.types';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import ActivityLogComponent from './activityLog.component';
import { getAllCountries } from 'country-locale-map';
import {
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { fetchEnumerations } from 'modules/authorizations/utils/fetchDataDetailsService';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  }
});

const VoucherActivityLogView = props => {
  const voucherIdParam = props.match?.params?.voucherId ?? '0';
  const voucherId = Number.parseInt(voucherIdParam, 10);

  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      await fetchEnumerations(props);
      const response = await props.getAuthorizationVoucherLogs(voucherId);
      if (response.type === GET_ACTIVITY_LOG_VOUCHER_FAILURE) {
        props.showToast('Failed to retrieve activity logs for this voucher.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        setLogs(response.response);
      }
      setIsLoading(false);
    }

    fetchData();
  }, []);

  return (
    <Box>
      {!isLoading && logs && (
        <Box sx={{ padding: 3 }}>
          <ActivityLogComponent logs={logs} enumerations={props.enumerations ? props.enumerations.allEnums : {}} />
        </Box>
      )}
      {isLoading && <FullscreenSpinner />}
    </Box>
  );
};

const mapStateToProps = state => {
  const enumerations = state.enumerations;
  return {
    enumerations
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationVoucherLogs: getVoucherLogs,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries
  })
)(VoucherActivityLogView);
